import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { CSSProperties } from 'react';
import Icon from 'features/shared/components/icons/Icon';
import styles from './infoitem.module.scss';
import { ColorClassSuffix } from 'features/shared/enums/colorClassSuffix';

interface Props {
  title: string;
  value?: string | JSX.Element;
  valueBold?: boolean;
  icon?: IconProp;
  iconColorClass?: string;
  className?: string;
}

const InfoItem = ({ title, value = "", valueBold = true, icon, iconColorClass, className }: Props) => {
  // helpers
  const getColorClass = (iconColorClass?: string) => {
    if (iconColorClass) {
      return iconColorClass;
    }
    else {
      return styles.defaulIcon;
    }
  }

  // render
  return (
    <div className={`d-flex align-items-center${className ? " " + className : ""}`}>
      {icon !== undefined &&
        <span 
          className={`mr-3 ${getColorClass(iconColorClass)}`}
        >
          <Icon icon={icon} size="2x" fixedWidth />
        </span>
      }
      <div className={`d-flex flex-column ${styles.valueCol}`}>
        <div className="text-muted">{title}</div>
        <div className={`mt-n1 ${valueBold ? "font-weight-bold" : ""}`}>{value}</div>
      </div>
    </div>
  )
}

export default InfoItem;
